import debounce from 'lodash/debounce';
import maintain from 'ally.js/esm/maintain/_maintain';
import {triggerEvent} from '../base/utils';

class Accordion {
    constructor($element, config = {item: '.accordion-item', trigger: '.accordion-trigger', body: '.accordion-body', bodyInner: '.accordion-body-inner'}) {
        this.config = config;
        this.$accordion = $element;
        this.$items = this.$accordion.querySelectorAll(this.config.item);

        this.disabledHandler = {};

        this.events();
    }

    events() {
        [...this.$items].forEach($item => {
            let $trigger = $item.querySelector(this.config.trigger),
                $body = $item.querySelector(this.config.body);

            $trigger.addEventListener('click', this.toggle.bind(this, $trigger, $body));
            $body.style.height = $body.querySelector(this.config.bodyInner).offsetHeight + 'px';

            if ($trigger.getAttribute('aria-expanded') === 'false') {
                this.disabledHandler[$trigger.id] = maintain.disabled({
                    context: $body
                });
            }
        });

        window.addEventListener('resize', debounce(this.handleResize.bind(this), 100));
        this.$accordion.addEventListener('resize', debounce(this.handleResize.bind(this), 100));
    }

    toggle($trigger, $body) {
        let doClose = $trigger.getAttribute('aria-expanded') === 'true';

        $body.style.height = $body.querySelector(this.config.bodyInner).offsetHeight + 'px';
        $trigger.setAttribute('aria-expanded', !doClose);
        $body.setAttribute('aria-hidden', doClose);
        $body.setAttribute('tabindex', doClose ? '-1' : '0');

        if (doClose) {
            this.disabledHandler[$trigger.id] = maintain.disabled({
                context: $body
            });
        } else {

            this.disabledHandler[$trigger.id] = null;
        }

        setTimeout(() => {
            triggerEvent($body, 'accordionchange');
        }, 100);
    }

    handleResize() {
        [...this.$accordion.querySelectorAll('[aria-hidden="false"]')].forEach($body => {
            $body.style.height = $body.querySelector(this.config.bodyInner).offsetHeight + 'px';
        });
    }
}

export default Accordion;



// WEBPACK FOOTER //
// ./sources/js/components/accordion.js